import { GroupResponseDto } from '../dtos/group/group.response.dto';
import { GroupRequestDto } from '../dtos/group/group.request.dto';
import { Group, GroupCreateData } from '@domain/group/group';
import { ParticipantMapper } from './participant.mapper';

export class GroupMapper {
  static fromDto(dto: GroupResponseDto): Group {
    const participants = (dto.participants ?? []).map(p => ParticipantMapper.fromDto(p));
    return new Group(dto.id, dto.nom, dto.description, participants);
  }

  static toRequestDto(data: GroupCreateData): GroupRequestDto {
    return {
      nom: data.nom,
      description: data.description,
      participants: data.participantIds.map(id => ({ id })),
      dispositifId: data.dispositifId,
    };
  }
}
